module.exports = __webpack_public_path__ + "img/36.fd494cba.jpg";